module.exports = __webpack_public_path__ + "public/img/logo-aidia.9e982307.png";